import { AttributeName, TreatmentType, Score } from "@keita/lanepatrol-sdk";
import { CraAttributeFilter, ScoreFilters } from "../../map/models/MapFilters";
import { Treatment } from "../../osaway/models/OsaNode";
import { ScoreImpact } from "../../coding/models/ScoreImpact";

type wayAndNodeId = string;

export interface CraForecastScenario {
  id: string;
  projectId: string;
  name: string;
  actions: CraForecastAction[];
  createdAt: string;
  createdById: string;
}

export interface CraForecastActionRequest {
  change: CraForecastChange;
  filters: CraForecastFilters;
}

export interface CraForecastFilters {
  osaWayFilters: string[];
  scoreFilters: ScoreFilters;
  treatmentFilters: TreatmentType[];
  attributeFilters: CraAttributeFilter[];
}

export interface CraForecastAction extends CraForecastActionRequest {
  results?: Map<wayAndNodeId, CraSimulatedResult>;
}

export type CraForecastChange =
  | {
      type: CraForecastChangeType.HighestPriorityTreatment;
    }
  | {
      type: CraForecastChangeType.TreatmentWhenSuggested;
      treatmentType: TreatmentType;
    }
  | {
      type: CraForecastChangeType.AttributeValues;
      attributeValues: { [key in AttributeName]?: string };
    };

export enum CraForecastChangeType {
  HighestPriorityTreatment = "HighestPriorityTreatment",
  TreatmentWhenSuggested = "TreatmentWhenSuggested",
  AttributeValues = "AttributeValues",
}

export interface CraSimulatedResult {
  score: Score;
  scoreImpact: ScoreImpact;
  treatments: Treatment[];
}

export interface CreateCraForecastScenarioRequest {
  projectId: string;
  name: string;
  actions: CraForecastActionRequest[];
}

export interface UpdateCraForecastScenarioRequest {
  name: string;
  actions: CraForecastActionRequest[];
}
